import { render, staticRenderFns } from "./ProjectDetailDialog.vue?vue&type=template&id=6b7b8a0e&scoped=true"
import script from "./ProjectDetailDialog.vue?vue&type=script&lang=js"
export * from "./ProjectDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetailDialog.vue?vue&type=style&index=0&id=6b7b8a0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7b8a0e",
  null
  
)

export default component.exports